export const TRANSLATIONS_JP_HOME_ACTIONS_AND_OVERVIEW = {
  "home.title": "検索拡張生成システム",
  "home.lead": "ドキュメントのコンテキスト情報で言語モデルの回答を強化します。",
  "home.description":
    "ドキュメントをアップロードし、クエリを実行し、自分の情報に基づいた正確な回答を得ましょう。",
  "home.upload_btn": "ドキュメントをアップロード",
  "home.query_btn": "クエリを実行",
  "home.feature_processing_title": "ドキュメント処理",
  "home.feature_processing_desc":
    "S3に保存または直接アップロードされたPDF、Word、TXTドキュメントからテキストを抽出します。",
  "home.feature_embeddings_title": "埋め込みとベクトル化",
  "home.feature_embeddings_desc":
    "高度な埋め込みモデルでテキストをベクトル化し、セマンティック検索を実現します。",
  "home.feature_generation_title": "回答生成",
  "home.feature_generation_desc":
    "高度な言語モデルでドキュメントに基づいた正確な回答を取得します。",
  "home.general.loading": "テレメトリを読み込み中...",
  "home.general.retry": "再試行",
  "home.general.retryAfter": "再試行まで",
  "home.general.actionUnavailableTitle": "操作できません",
  "home.general.actionUnavailableMessage": "この操作を完了するための情報が不足しています。",
  "home.pagination.previous": "前へ",
  "home.pagination.next": "次へ",
  "home.shared.aiBadge": "AI生成シグナル",
  "home.shared.detectedBadge": "自動検出",
  "home.shared.prioritizedBadge": "AI優先度",
  "home.shared.recommendationBadge": "優先推奨",
  "home.reasonCode.due_soon": "期限が近い",
  "home.reasonCode.overdue": "期限切れ",
  "home.reasonCode.high_priority": "高優先度",
  "home.reasonCode.compliance_required": "コンプライアンス対応",
  "home.reasonCode.needs_review": "要確認",
  "home.reasonCode.pending_review": "確認待ち",
  "home.decisionStates.act_now": "今すぐ対応",
  "home.decisionStates.act_soon": "まもなく対応",
  "home.decisionStates.act_without_rush": "急がなくてよい",
  "home.decisionStates.waiting": "対応予定",
  "home.decisionStates.blocked": "情報待ち",
  "home.decisionStates.in_review": "レビュー中",
  "home.decisionStates.dismissed": "対象外",
  "home.decisionStates.safe_to_ignore": "無視してよい",
  "home.decisionStates.completed": "解決済み",
  "home.attention.sectionTitle": "要対応",
  "home.attention.followUpTitle": "フォローアップ",
  "home.attention.allClearTitle": "すべて対応済み",
  "home.attention.allClearCopy": "現在、対応が必要な項目はありません。",
  "home.decisionDisplay.priority.critical.label": "重大",
  "home.decisionDisplay.priority.critical.copy": "期限切れ、または業務影響を生む可能性があります。",
  "home.decisionDisplay.priority.high.label": "高",
  "home.decisionDisplay.priority.high.copy": "期限が近く、確認が必要です。",
  "home.decisionDisplay.priority.medium.label": "中",
  "home.decisionDisplay.priority.medium.copy": "ブロックや遅延を避けるため、近いうちに確認してください。",
  "home.decisionDisplay.priority.low.label": "低",
  "home.decisionDisplay.priority.low.copy": "今は監視を続ければ十分です。",
  "home.decisionDisplay.risk.critical.label": "重大リスク",
  "home.decisionDisplay.risk.critical.copy": "重要な業務を止めたり、即時の不遵守を招く可能性があります。",
  "home.decisionDisplay.risk.high.label": "高リスク",
  "home.decisionDisplay.risk.high.copy": "支払い、コンプライアンス、運用継続に影響する可能性があります。",
  "home.decisionDisplay.risk.medium.label": "中リスク",
  "home.decisionDisplay.risk.medium.copy": "遅延、手戻り、追加フォローを生む可能性があります。",
  "home.decisionDisplay.risk.low.label": "低リスク",
  "home.decisionDisplay.risk.low.copy": "適時に確認すれば運用影響は限定的です。",
  "home.decisionDisplay.risk.none.label": "リスク確認待ち",
  "home.decisionDisplay.risk.none.copy": "リスクを評価するための文脈がまだ不足しています。",
  "home.decisionDisplay.confidence.high.label": "高い信頼度",
  "home.decisionDisplay.confidence.high.copy": "推奨は利用可能な根拠と整合しています。",
  "home.decisionDisplay.confidence.medium.label": "中程度の信頼度",
  "home.decisionDisplay.confidence.medium.copy": "確定前に主要な根拠を確認してください。",
  "home.decisionDisplay.confidence.low.label": "低い信頼度",
  "home.decisionDisplay.confidence.low.copy": "行動する前に根拠を確認してください。",
  "home.decisionSummary.eyebrow": "状態",
  "home.decisionSummary.title": "決定サマリー",
  "home.decisionList.eyebrow": "受信箱",
  "home.decisionList.title": "コンパクトな決定リスト",
  "home.decisionList.filteredTitle": "絞り込み済み決定",
  "home.decisionList.empty": "表示できる決定はまだありません。",
  "home.decisionList.emptyFiltered": "この状態の決定はありません。",
  "home.viewMode.current": "現在の表示",
  "home.viewMode.calendar": "カレンダー",
  "home.decisionActionForm.title": "必要な入力",
  "home.decisionActionForm.selectPlaceholder": "オプションを選択",
  "home.decisionActionForm.required": "続行するにはこの項目を入力してください。",
  "home.decisionActionForm.confirmExecution": "この運用アクションを実行してよいことを確認します。",
  "home.decisionActionForm.confirmRequired": "続行する前にアクションを確認してください。",
  "home.decisionActionForm.submit": "アクションを実行",
  "home.decisionActionForm.cancel": "キャンセル",
  "home.decisionActionUx.blockedCopy": "この決定は今重要ですが、ブロック要因が解決されるまで完了できません。",
  "home.decisionActionUx.blockedReason": "最終アクションを実行する前にブロック要因を解決してください。",
  "home.decisionActionUx.blockedTitle": "緊急ですがブロック中",
  "home.decisionActionUx.catalogCopy": "決定のソースが安定しておらず、最終アクションを実行できません。",
  "home.decisionActionUx.catalogReason": "推奨が劣化したため、手動での確認が必要です。",
  "home.decisionActionUx.catalogTitle": "推奨には検証が必要です",
  "home.decisionActionUx.completeMissingInfo": "不足している情報を確認",
  "home.decisionActionUx.completedCopy": "この決定に保留中のアクションはありません。",
  "home.decisionActionUx.completedReason": "この決定はすでに解決済みです。",
  "home.decisionActionUx.completedTitle": "決定は解決済み",
  "home.decisionActionUx.confirmRequiredData": "必要なデータを確認",
  "home.decisionActionUx.disabledCopy": "主要なアクションを再度有効にする前に、この決定の確認が必要です。",
  "home.decisionActionUx.disabledTitle": "アクションは利用できません",
  "home.decisionActionUx.lowConfidenceCopy": "証拠と信頼度を確認するまで、この決定を実行しないでください。",
  "home.decisionActionUx.lowConfidenceReason": "信頼度が低すぎるため、最終アクションを実行できません。",
  "home.decisionActionUx.lowConfidenceTitle": "この推奨には確認が必要です",
  "home.decisionActionUx.missingInfoCopy": "このパネルで不足している情報を確認し、アクションを再試行する前に元の文書またはシステムでデータを補完してください。",
  "home.decisionActionUx.missingInfoReason": "そのデータが元のソースに存在するまで、最終アクションはブロックされたままです。",
  "home.decisionActionUx.missingInfoTitle": "必要な情報が不足しています",
  "home.decisionActionUx.noActionCopy": "この決定にはまだ確定したアクションがありません。",
  "home.decisionActionUx.noActionTitle": "確定したアクションなし",
  "home.decisionActionUx.readyCopy": "この決定は次のアクションの準備ができています。",
  "home.decisionActionUx.readyTitle": "今すぐ対応できます",
  "home.decisionActionUx.resolveBlock": "ブロック要因を表示",
  "home.decisionActionUx.reviewEvidence": "証拠を確認",
  "home.decisionActionUx.reviewRecommendation": "推奨を確認",
  "home.decisionActionUx.reviewRequirements": "要件を確認",
  "home.decisionActionUx.safeToIgnoreCopy": "介入せずにこの決定を監視のままにできます。",
  "home.decisionActionUx.safeToIgnoreReason": "この決定は即時の対応なしで監視を継続できます。",
  "home.decisionActionUx.safeToIgnoreTitle": "今は対応不要",
  "home.decisionActionUx.waitingCopy": "この決定は外部シグナルまたは保留中の更新に依存しています。",
  "home.decisionActionUx.waitingLabel": "更新を待つ",
  "home.decisionActionUx.waitingReason": "Home IA はこのアクションを有効にする条件をまだ待っています。",
  "home.decisionActionUx.waitingTitle": "まだ対応できません",
};
